/* eslint-disable react/button-has-type */
import { useAuth } from 'react-oidc-context';

import { AddOnGroup, InputGroup, InputLabel, InputStyle } from './login.styled';

interface IFormGroup {
  label: string;
  addOn?: JSX.Element;
  endButton?: JSX.Element;
  hasError?: boolean;
  [key: string]: unknown;
}

export const FormGroup = ({ addOn, endButton, hasError, label, ...props }: IFormGroup) => {
  return (
    <div
      style={{
        marginBottom: '18px',
      }}
    >
      <InputLabel>{label}</InputLabel>
      <InputGroup hasError={!!hasError}>
        {addOn && <AddOnGroup>{addOn}</AddOnGroup>}
        <InputStyle {...props} />
        {endButton}
      </InputGroup>
    </div>
  );
};

// eslint-disable-next-line consistent-return
export const TinyLogin = () => {
  const auth = useAuth();

  if (auth.isLoading) {
    return <div>Loading...</div>;
  }

  if (auth.error) {
    return <div>Oops... {auth.error.message}</div>;
  }

  if (auth.isAuthenticated) {
    return (
      <div>
        Hello {auth.user?.profile.sub} <button onClick={() => auth.removeUser()}>Log out</button>
      </div>
    );
  }
  auth.signinRedirect();
  return <></>;
};
